import { useAuth } from "../contexts/AuthContext";

/**
 * Interpreta contenido con etiquetas {mlang xx}...{mlang} y devuelve
 * solo el texto correspondiente al idioma actual, con fallback a inglés.
 *
 * @param {string} text - Contenido con etiquetas {mlang}.
 * @param {string} currentLang - Idioma actual (ej: "es", "es_mx", "en").
 * @returns {string} - Contenido filtrado.
 */
function renderMultilang(text, currentLang) {
  if (!text || !currentLang) return text;

  // Extraer todos los bloques {mlang}
  const blocks = [];
  const regex = /\{mlang\s+([^\}]+)\}([\s\S]*?)\{mlang\}/g;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const langs = match[1].split(",").map((l) => l.trim().toLowerCase());
    const content = match[2];
    blocks.push({ langs, content });
  }

  // Si no hay bloques {mlang}, retornar el texto original
  if (blocks.length === 0) return text;

  const userLang = currentLang.toLowerCase();
  console.log(`🔍 Buscando contenido para idioma: ${userLang}`);
  console.log(`📝 Bloques encontrados:`, blocks.map(b => ({ langs: b.langs, preview: b.content.trim().substring(0, 50) + '...' })));

  // 1. Buscar coincidencia exacta
  for (const block of blocks) {
    if (block.langs.includes(userLang)) {
      console.log(`✅ Coincidencia exacta encontrada para ${userLang}`);
      return block.content;
    }
  }

  // 2. Si usuario tiene subidioma (ej: es_mx → es)
  if (userLang.includes("_")) {
    const parent = userLang.split("_")[0];
    for (const block of blocks) {
      if (block.langs.includes(parent)) {
        console.log(`✅ Coincidencia de idioma padre encontrada: ${parent}`);
        return block.content;
      }
    }
  }

  // 3. Si el usuario usa idioma base, buscar subidiomas (ej: es → es_mx)
  if (!userLang.includes("_")) {
    for (const block of blocks) {
      const matches = block.langs.filter((l) => l.startsWith(userLang + "_"));
      if (matches.length > 0) {
        console.log(`✅ Coincidencia de subidioma encontrada: ${matches[0]}`);
        return block.content;
      }
    }
  }

  // 4. FALLBACK: Buscar contenido en inglés
  for (const block of blocks) {
    if (block.langs.includes("en")) {
      console.log(`🔄 Usando fallback en inglés`);
      return block.content;
    }
  }

  // 5. FALLBACK: Buscar "other"
  for (const block of blocks) {
    if (block.langs.includes("other")) {
      console.log(`🔄 Usando fallback "other"`);
      return block.content;
    }
  }

  // 6. ÚLTIMO RECURSO: Retornar el primer bloque disponible
  if (blocks.length > 0) {
    console.log(`⚠️ Sin coincidencias, usando primer bloque disponible`);
    return blocks[0].content;
  }

  console.log(`❌ Sin contenido multilang encontrado`);
  return text; // Retornar texto original si no hay nada
}

export function MultiLangText({ content, currentLang }) {
  const { lang }  = useAuth()
  const activeLang =  lang || 'es'
  const filtered = renderMultilang(content, activeLang);
  return <>{filtered}</>;
}
